import React from 'react';
import { Award, Users, TrendingUp, Shield } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const About = () => {
  const stats = [
    { icon: Award, value: '15+', label: 'Jahre Erfahrung' },
    { icon: Users, value: '300+', label: 'Zufriedene Kunden' },
    { icon: TrendingUp, value: '500+', label: 'Projekte realisiert' },
    { icon: Shield, value: '20+', label: 'Mitarbeiter' }
  ];

  return (
    <section id="ueber-uns" className="py-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-3 block">
              Über uns
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Ihr zuverlässiger Partner
              <span className="block text-slate-700">in München</span>
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              {companyInfo.description}
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Unter der Leitung von <strong>{companyInfo.managingDirector}</strong> haben wir uns als
              verlässlicher Partner für Gebäudetechnik in München etabliert. Unser Anspruch:
              höchste Qualität, pünktliche Umsetzung und persönliche Betreuung.
            </p>

            {/* Company Details */}
            <div className="bg-white border-l-4 border-orange-500 rounded-lg p-6 shadow-md">
              <h3 className="font-bold text-slate-900 mb-3">Firmendaten</h3>
              <div className="space-y-2 text-gray-600">
                <p><strong>Geschäftsführer:</strong> {companyInfo.managingDirector}</p>
                <p><strong>Registergericht:</strong> {companyInfo.tradeRegister}</p>
                <p><strong>Standort:</strong> {companyInfo.address}, {companyInfo.city}</p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.15}s both`
                  }}
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-xl flex items-center justify-center mb-4">
                    <IconComponent className="text-white" size={28} />
                  </div>
                  <div className="text-3xl font-bold text-slate-900 mb-2">{stat.value}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};